import React, {ReactElement} from 'react';
import ReactDOM from 'react-dom';

const ReactStars = require('react-rating-stars-component').default;

interface StarRatingProps {
  rating: number;
  size?: number;
}

const StarRating: React.FC<StarRatingProps> = ({
   rating,
   size = 19
 }): ReactElement => {
  return (
    <ReactStars
      count={5}
      value={rating}
      edit={false}
      size={size}
      isHalf={true}
      activeColor="#efbc08"
      color="#E6E6E6"
    />
  );
};

export default StarRating;

if (document.getElementsByClassName('react-star-rating').length > 0) {
  document.querySelectorAll('.react-star-rating')
    .forEach((element) => {
      const rating = JSON.parse(element.getAttribute('data-rating') ?? '0');
      ReactDOM.render(<StarRating rating={rating} />, element);
    });
}

